<div class="chart-container">
  <lib-machine-chart
  [workCenterId]="workCenterId"
  [isAutoUpdate]="true"
  [isFullViewMode]="true"
  [showMachineList]="true"
  [chartMode]="chartMode"
></lib-machine-chart>
</div>
